var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUsDdark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 11.5,
    fill: "#141619",
    stroke: "#2E333A"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.8662 11.2667C10.3529 10.8733 9.86622 10.4667 9.86622 9.83333C9.86622 9.10667 10.5396 8.6 11.6662 8.6C12.8529 8.6 13.2929 9.16667 13.3329 10H14.8062C14.7596 8.85333 14.0596 7.8 12.6662 7.46V6H10.6662V7.44C9.37289 7.72 8.33289 8.56 8.33289 9.84667C8.33289 11.3867 9.60622 12.1533 11.4662 12.6C13.1329 13 13.4662 13.5867 13.4662 14.2067C13.4662 14.6667 13.1396 15.4 11.6662 15.4C10.2929 15.4 9.75289 14.7867 9.67956 14H8.21289C8.29289 15.46 9.38622 16.28 10.6662 16.5533V18H12.6662V16.5667C13.9662 16.32 14.9996 15.5667 14.9996 14.2C14.9996 12.3067 13.3796 11.66 11.8662 11.2667Z",
    fill: "#6C7C8C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsDdark);
export default __webpack_public_path__ + "static/media/USDdark.8167f8ffa894b6fac62e147c1692dfa8.svg";
export { ForwardRef as ReactComponent };